"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var StreetAddressFormatHint = /** @class */ (function (_super) {
    tslib_1.__extends(StreetAddressFormatHint, _super);
    function StreetAddressFormatHint(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showHint: false,
        };
        return _this;
    }
    StreetAddressFormatHint.prototype.componentWillReceiveProps = function (nextProps) {
        this.checkStreetAddressFormatting(nextProps.streetAddress);
    };
    StreetAddressFormatHint.prototype.checkStreetAddressFormatting = function (rawText) {
        var inputText = rawText.trim();
        if (this.inputHasOneWord(inputText) && this.inputHasNoNumbers(inputText)) {
            this.setState({ showHint: true });
        }
        else {
            this.setState({ showHint: false });
        }
    };
    StreetAddressFormatHint.prototype.inputHasOneWord = function (text) {
        var singleWordRegex = new RegExp(/^[^\s]*$/);
        return singleWordRegex.test(text);
    };
    StreetAddressFormatHint.prototype.inputHasNoNumbers = function (text) {
        var noNumberRegex = new RegExp(/^[^0-9]+$/);
        return noNumberRegex.test(text);
    };
    StreetAddressFormatHint.prototype.display = function () {
        return {
            display: this.state.showHint ? 'block' : 'none',
        };
    };
    StreetAddressFormatHint.prototype.render = function () {
        return (React.createElement("div", { ref: "streetAddressFormatHint", style: this.display(), className: "alert alert-warn alert-tiny mt-0" },
            React.createElement("p", { className: "size-90" }, I18n.t('discovery.bundledCheckout.streetAddressFormatHint.hint'))));
    };
    return StreetAddressFormatHint;
}(React.Component));
exports.default = StreetAddressFormatHint;
//# sourceMappingURL=street_address_format_hint.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/addresses/street_address_format_hint.js
// module id = MnG4
// module chunks = 20 21 22